import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../store";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import LinkAuto from "../autocomplete/linkAutocomplete";
import { CalendarIcon, ReverseIcon } from "../common/icons/svg";
import { apiUrl, getLinkCity } from "../common/constants";
import {
    findKey,
    getRevDate,
    getDateForSrch,
    fetchGet,
} from "../../common/common";
import { renderImg } from "../common/icons/img";
import Checkbox from "../common/input/checkbox";
import { t, SINGLE_LADY } from "../../translations/Modify";
import { updateStaticCityList, updateCityList } from "../../actions/search-actions";

class LinkModify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prevLink: "",
            nextLink: "",
            from: this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[1] + (this.props.search.searchParams.stationInFromCity && this.props.search.searchParams.stationInFromCity.split("|")[0] && ', ' + this.props.search.searchParams.stationInFromCity.split("|")[0].replace(/[^a-zA-Z]/g, " ")),
            to: this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[5] + (this.props.search.searchParams.stationInToCity && this.props.search.searchParams.stationInToCity.split("|")[0] && ', ' + this.props.search.searchParams.stationInToCity.split("|")[0].replace(/[^a-zA-Z]/g, " ")),
            linkCity: this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[3],
            staticCityList: {},
            cityList: {},
            fromList: [],
            toList: [],
            boardingList: [],
            droppingList: [],
            linkcityList: [],
            boardingPoint: this.props.search.searchParams.stationInFromCity && this.props.search.searchParams.stationInFromCity.split("|")[0].replace(/[^a-zA-Z]/g, " "),
            droppingPoint: this.props.search.searchParams.stationInToCity && this.props.search.searchParams.stationInToCity.split("|")[0].replace(/[^a-zA-Z]/g, " "),
            focused: false,
            retFocused: false,
            fromErr: false,
            toErr: false,
            depErr: false,
            swapErr: false,
            journeyDate: getRevDate(this.props.search.searchParams.departDate),
            depDate: moment(
                new Date(getRevDate(this.props.search.searchParams.departDate))
            ),
            retDate:
                this.props.search.searchParams.mode === "oneway"
                    ? null
                    : moment(
                        new Date(getRevDate(this.props.search.searchParams.returnDate))
                    ),
            alerterror: "",
            stophourList: [0, 2, 3, 4, 5, 6, 7, 8, 9],
            stophourLabel: [],
            stophourVal: this.props.search.searchParams.stophour && this.props.search.searchParams.stophour,
            stophour: this.props.search.searchParams.stophour && this.props.search.searchParams.stophour > 0 ? this.props.search.searchParams.stophour + ' Hours' : this.props.search.searchParams.stophour,
            linkfromCityId: this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[0],
            linktoCityId: this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[4],
            singleLady: this.props.search.searchParams.IsSingleLady == 1 ? 1 : 0,
            singleLadyDisabled: (this.props.search.searchParams.IsSingleLady == 1 && this.props.search.searchParams.mode == "roundtrip" && this.props.search.searchParams.token) ? 1 : 0,
        };
    }

    componentDidMount() {
        const that = this;
        /*         const url = window.url + apiUrl.getcities;
                fetchGet(url)
                    .then(function (data) {
                        const cityList = data;
                        let fromList = [];
                        let toList = [];
                        Object.keys(data).forEach((el, index) => {
                            fromList.push(data[el].Name);
                            const fromCityKey = Object.keys(cityList).find(
                                (key) =>
                                    cityList[key].Name ===
                                    that.props.search.searchParams.fromCity.split("|")[1]
                            );
                            if (el === fromCityKey) {
                                Object.keys(data[el].ToCities).forEach((val) =>
                                    toList.push(data[el].ToCities[val])
                                );
                            }
                        });
                        that.setState({ cityList, fromList, toList });
                    })
                    .catch(function (error) {
                        console.log(error);
                    }); */

        this.getStaticCityList();
        this.parseNextPrevLinks();
        this.loadLinkCity(this.state.linkfromCityId, this.state.linktoCityId,this.state.journeyDate);
    }

    getStaticCityList = () => {

        const that = this;

        if (Object.keys(that.props.search.staticCityList).length > 0) {
            const staticCityList = that.props.search.staticCityList;
            that.parseStaticCityList(staticCityList);
            setTimeout(() => {
                that.getCityList();
            }, 100)
        } else {
            const url = window.cdnUrl + apiUrl.getStaticCity;
            fetchGet(url)
                .then(function (response) {
                    if (response.success) {
                        const staticCityList = response.data;
                        store.dispatch(updateStaticCityList(staticCityList));
                        that.parseStaticCityList(staticCityList);
                        that.getCityList();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

    parseStaticCityList = (staticCityList) => {

        let that = this;
        let cityList = {};
        let fromList = [];
        let toList = [];

        Object.entries(staticCityList).forEach(([index, cityObj]) => {
            cityList[index] = { Name: cityObj.Name, Key: cityObj.Key, ID: cityObj.ID, ToCities: staticCityList };
            fromList.push({ Name: cityObj.Name, Key: cityObj.Key, ID: cityObj.ID });
            toList.push({ Name: cityObj.Name, Key: cityObj.Key, ID: cityObj.ID });
        });

        that.setState({ staticCityList, cityList, fromList, toList });
    }

    getCityList = () => {
        const that = this;

        if (Object.keys(that.props.search.cityList).length > 0) {
            const cityResData = that.props.search.cityList;
            that.parseCityList(cityResData)

        } else {
            const url = window.cdnUrl + apiUrl.getCityList;
            fetchGet(url)
                .then(function (cityResponse) {
                    if (cityResponse.success) {
                        const cityResData = cityResponse.data;
                        store.dispatch(updateCityList(cityResData));
                        that.parseCityList(cityResData)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }


    parseCityList = (cityResData) => {

        let that = this;
        const staticCityList = that.state.staticCityList;
        const staticCityList2 = that.state.staticCityList;
        let cityList = {};
        let fromList = [];
        let toList = [];
        let index = 0;

        Object.entries(cityResData).forEach(([frCityId, toCitiesArr]) => {
            Object.entries(staticCityList).forEach(([i, stCity]) => {

                //for find fromcity object by matching cityid
                if (stCity.ID == frCityId) {
                    const frCityObj = stCity;
                    const ToCities = [];

                    //for fromcity create tocities object data
                    toCitiesArr.forEach((toCityId) => {
                        Object.entries(staticCityList2).forEach(([j, stToCity]) => {
                            if (stToCity.ID == toCityId) {
                                ToCities.push(stToCity);
                            }
                        });
                    });

                    //for create citylist array with fromcity object and tocites object date
                    cityList[index] = { Name: frCityObj.Name, Key: frCityObj.Key, ID: frCityObj.ID, ToCities: ToCities };

                    //for create fromcity object list
                    fromList[index] = { Name: frCityObj.Name, Key: frCityObj.Key, ID: frCityObj.ID };

                    //for selected fromcity create tocities object data
                    if (frCityObj.Name == that.props.search.searchParams.fromCity.split("|")[1]) {
                        toList = ToCities;
                    }

                    index++;
                }
            });
        });

        that.setState({ cityList, fromList, toList });
    }

    loadLinkCity = (fromCityId, toCityId,journeyDate) => {
        // const fromCityId = this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[0];
        // const toCityId = this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[4];
        const that = this;
        const url = window.url + apiUrl.getLinkCity + "?fromCityId=" + fromCityId + "&toCityId=" + toCityId + "&journeyDate="+journeyDate;
        fetchGet(url)
            .then(function (data) {
                //console.log("pickStations", data);
                if (data.IsSuccess) {
                    const linkpairs = data.data;
                    that.setState({ linkcityList: [...linkpairs] })
                }
                else {
                    this.setState({ linkcityList: [] })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    parseNextPrevLinks = () => {
        const departDate = new Date(
            getRevDate(this.props.search.searchParams.departDate)
        );
        const currDate = new Date(new Date(window.today).toDateString());
        let tomorrow = new Date(departDate);
        let yesterday = new Date(departDate);
        let dayBeforeTomorrow = new Date(departDate);
        let maxDate = new Date(window.today);
        maxDate.setDate(new Date(maxDate.getDate() + window.daysForCalendar));
        tomorrow.setDate(departDate.getDate() + 1);
        yesterday.setDate(departDate.getDate() - 1);

        const prevLink =
            currDate < yesterday ? this.getSearchUrl(yesterday) : false;
        const nextLink = (dayBeforeTomorrow.getDate() === maxDate.getDate() && dayBeforeTomorrow.getMonth() === maxDate.getMonth()) ? false : this.getSearchUrl(tomorrow);
        this.setState({ prevLink, nextLink });
    };

    getSearchUrl = (val) => {
        const dt = "departDate=" + this.getFormattedDateForURL(val);
        let srchUrl = "/search/";
        const srchParams = window.location.search;
        let tempDt =
            srchParams.indexOf("departDate=") >= 0
                ? srchParams.split("departDate=")
                : false;
        tempDt[1] =
            tempDt[1].indexOf("&") >= 0
                ? tempDt[1].substr(tempDt[1].indexOf("&"))
                : "";
        srchUrl += tempDt[0] + dt + tempDt[1];
        return srchUrl;
    };

    getFormattedDateForURL = (dateString) => {
        //dateString = dateString.replace(/-/g, ' '); //firefox doesn't understand hyphens in date
        const d = dateString;
        let day = d.getDate(),
            month = d.getMonth() + 1,
            year = d.getFullYear();

        if (day < 10) day = "0" + day;
        if (month < 10) month = "0" + month;

        return day + "-" + month + "-" + year;
    };

    setFrom = (from, param, type = '') => {

        let toList = param ? [] : this.state.toList;
        let toCityKey = 0;
        if (param) {
            const cityList = this.state.cityList;
            if (from === "") {
                const list = cityList[Object.keys(cityList)[0]].ToCities;
                Object.keys(list).forEach((el) => toList.push(list[el]));
            } else {
                const fromCitykey = findKey(cityList, from, "Name");

                if (cityList[fromCitykey] !== undefined) {
                    const list = cityList[fromCitykey].ToCities;
                    Object.keys(list).forEach((el) => toList.push(list[el]));
                }

                if (type === 'selCity') {
                    this.setState({ to: '' });
                }

                // if (fromCitykey) {
                //     toCityKey =
                //     fromCitykey &&
                //         Object.keys(this.state.cityList[fromCitykey].ToCities).find(
                //             (key) => this.state.cityList[fromCitykey].ToCities[key] === to
                //     );
                // }
                // this.loadPickStations(key);

                // this.loadLinkCity(key)
            }
        }

        if (param === "true") {

            console.log(param, "==true");

            const fromCityObj = Object.values(toList).find((el) => {
                return el.Name === this.state.from;
            });

            if (fromCityObj === undefined) {
                from = this.state.from;
                const to = this.state.to;
                toList = this.state.toList;
                this.setState({
                    from,
                    toList,
                    to,
                    swapErr: true,
                    alerterror: to + " to " + from + " route is not available.",
                });
            } else {
                this.setState({ from, toList, to: this.state.from });
            }

        } else {
            //this.setState({ from, toList, to: this.state.from, boardingPoint: '' });
            this.setState({ from, toList, boardingPoint: '' });
        }
    };

    setTo = (to, param) => {

        let fromCityKey, toCityKey = 0;
        fromCityKey = Object.keys(this.state.cityList).find(
            (key) => this.state.cityList[key].Name === this.state.from
        );

        toCityKey =
            fromCityKey &&
            Object.keys(this.state.cityList[fromCityKey].ToCities).find(
                (key) => this.state.cityList[fromCityKey].ToCities[key] === to
            );
        if (toCityKey) {
            // this.loadDropStations(toCityKey);
        }
        this.setState({ to, droppingPoint: '' });
    };

    setBoardingPoint = (val) => {
        this.setState({ boardingPoint: val })
    }

    setDropingPoint = (val) => {
        this.setState({ droppingPoint: val })
    }

    setlinkCity = (val) => {
        // let linkpoint = this.props.search.searchParams && this.props.search.searchParams.linkfromstoptocity && this.props.search.searchParams.linkfromstoptocity.split("|")[3];
        this.setState({ linkCity: val })
    }

    setStopHour = (val) => {
        let stophour = '';
        if (val > 1) {
            stophour = val + ' Hours';
        } else {
            stophour = val;
        }
        this.setState({ stophour, stophourVal: val })
    }

    checkOutsideRange = (param, e) => {
        let today = new Date(window.today);
        today.setHours(0, 0, 0, 0);
        let ninety = new Date(window.today);
        ninety = ninety.setDate(ninety.getDate() + window.daysForCalendar);
        if (param === "dep") {
            return !(today <= e._d && ninety > e._d);
        } else {
            if (this.state.depDate && this.state.depDate._d) {
                const depDate = this.state.depDate._d;
                return !(depDate <= e._d && ninety > e._d);
            } else {
                return !(today <= e._d && ninety > e._d);
            }
        }
    };

    swapCities = () => {
        // const from = this.state.from;
        const to = this.state.to.replace("+", " ");
        this.setFrom(to, "true");
        // this.setTo('', false);
    };

    modifySrch = () => {

        const from = this.state.from.replace("+", " ");
        const to = this.state.to.replace("+", " ");
        const departDate = this.state.depDate ? this.state.depDate._d : false;
        const returnDate = this.state.retDate ? this.state.retDate._d : false;
        const boardingList = this.state.boardingList;
        const droppingList = this.state.droppingList;
        let url = '';
        let fromStation, toStation, fromStationKey, tostationKey = '';

        if (!from || !to || !departDate) {
            let fromErr = !from ? true : false;
            let toErr = !to ? true : false;
            let depErr = !departDate ? true : false;
            this.setState({ fromErr, toErr, depErr });
            return;
        } else {

            if (this.props.search.searchParams.linkfromstoptocity) {

                let searchParams = this.props.search.searchParams;
                let linkfromStopTocity = searchParams?.linkfromstoptocity;

                if (linkfromStopTocity) {

                    let fromCity = linkfromStopTocity.split("|")[1].trim();
                    let fromCityId = linkfromStopTocity.split("|")[0].trim();
                    // let stopCity = linkfromStopTocity.split("|")[3].trim();
                    // let stopCityId = linkfromStopTocity.split("|")[2].trim();
                    let toCity = linkfromStopTocity.split("|")[5].trim();
                    let toCityId = linkfromStopTocity.split("|")[4].trim();

                    let linkCityList = this.state.linkcityList;
                    let linkCity = this.state.linkCity;

                    let filterlinkCity = linkCityList.filter(el => el.LinkCity.toLowerCase() === linkCity.toLowerCase())[0];
                    // console.log("filterlinkCity", filterlinkCity);
                    let fromCityKey = fromCityId + '|' + fromCity;
                    let ConnectKey = filterlinkCity.LinkCityID + '|' + filterlinkCity.LinkCity;
                    const depD = getDateForSrch(departDate);

                    linkfromStopTocity = fromCityKey + '|' + ConnectKey + '|' + toCityId + '|' + toCity;
                    let fromStation, toStation = '';
                    // console.log("kks", searchParams);
                    if (searchParams.stationInFromCity) {
                        fromStation = searchParams.stationInFromCity.split("|")[0].replace(/[^a-zA-Z]/g, " ") + '|' + searchParams.stationInFromCity.split("|")[1];
                    } else {
                        fromStation = '';
                    }

                    if (searchParams.stationInToCity) {
                        toStation = searchParams.stationInToCity.split("|")[0].replace(/[^a-zA-Z]/g, " ") + '|' + searchParams.stationInToCity.split("|")[1];
                    } else {
                        toStation = '';
                    }

                    url =
                        "/search?mode=roundtrip" +
                        "&fromCity=" +
                        fromCityKey +
                        "&toCity=" +
                        ConnectKey +
                        "&departDate=" +
                        depD +
                        "&returnDate=" +
                        depD +
                        "&stationInFromCity=" + fromStation +
                        "&stationInToCity=" + toStation +
                        "&linkfromstoptocity=" + linkfromStopTocity +
                        "&stophour=" + this.state.stophourVal +
                        "&src=h";

                    if (this.state.singleLady == 1) {
                        url += '&IsSingleLady=1';
                    } else {
                        url += '&IsSingleLady=0';
                    }

                    //console.log(url);
                    window.location.href = url;
                }
            }
            // else {
            //     this.setState({
            //         alerterror: to + " to " + from + " route is not available.",
            //     });
            // }
        }
    };


    showaertdialogue = () => {
        setTimeout(() => {
            this.setState({ alerterror: "" });
        }, 5000);
        return (
            <div
                className="blacklayer"
                onClick={() => {
                    this.setState({ alerterror: "" });
                }}
            >
                <div className="popupbox">
                    <div className="alertmsg">{this.state.alerterror}</div>
                    <button
                        className="alertbuttonok crsrpointer"
                        onClick={() => {
                            this.setState({ alerterror: "" });
                        }}
                    >
                        OK{" "}
                    </button>
                </div>
            </div>
        );
    };


    render() {

        let that = this;

        return (
            <section className="searchformsection">
                {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
                <div className="searchbar">
                    <LinkAuto
                        className="Fromcity cityinput disable"
                        list={this.state.fromList}
                        placeholder="Starting From"
                        value={this.state.from}
                        setValue={this.setFrom}
                        err={this.state.fromErr}
                        label="Starting From"
                        inputpadding="34px 16px 17px 16px"
                        spanclassname="mod-clear flex-vc"
                        style={{ width: '20%' }}
                        type={"startCity"}
                        linkCity={this.state.linkCity}
                    />
                    <LinkAuto
                        className={`Fromcity cityinput pickup--input ${this.state.linkCity ? 'filled' : ''}`}
                        list={this.state.linkcityList}
                        placeholder={`Link Point`}
                        value={this.state.linkCity}
                        setValue={this.setlinkCity}
                        err={this.state.toErr}
                        label={`Stopping at (Link Point)`}
                        inputpadding="34px 16px 17px 16px"
                        spanclassname="mod-clear flex-vc"
                        style={{ width: '20%', display: 'block' }}
                        type={"linkCity"}
                        linkCity={this.state.linkCity}
                    />
                    <LinkAuto
                        className="Tocity cityinput disable"
                        list={this.state.toList}
                        placeholder="Going To"
                        value={this.state.to}
                        setValue={this.setTo}
                        err={this.state.toErr}
                        label="Going To"
                        inputpadding="34px 16px 17px 16px"
                        spanclassname="mod-clear flex-vc"
                        style={{ width: '20%' }}
                        type={"toCity"}
                        linkCity={this.state.linkCity}
                    />
                    <div
                        className={
                            this.state.depErr ? "mo-inp err cityinput" : "mo-inp cityinput"
                        }
                        style={{ width: '20%' }}
                    >
                        <SingleDatePicker
                            id="onwardjdate"
                            readOnly={true}
                            date={this.state.depDate} // momentPropTypes.momentObj or null
                            onDateChange={(depDate) =>
                                this.setState({ depDate, retDate: null })
                            } // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                            hideKeyboardShortcutsPanel={true}
                            block={true}
                            numberOfMonths={2}
                            noBorder={true}
                            displayFormat="ddd MMM  DD YYYY"
                            placeholder="Choose date"
                            isOutsideRange={(event) => this.checkOutsideRange("dep", event)}
                            anchorDirection="left"
                            firstDayOfWeek={1}
                        />
                        <span className="mod-clear calendar">
                            {renderImg('CalendarIconGray')}
                        </span>
                        <label>Date of Departure</label>
                    </div>
                    {/* <LinkAuto
                        className="stophour cityinput"
                        list={this.state.stophourList}
                        placeholder="Stopover Duration"
                        value={this.state.stophour}
                        setValue={this.setStopHour}
                        err={this.state.toErr}
                        label="Minimum Stopover Duration "
                        inputpadding="34px 16px 17px 16px"
                        spanclassname="mod-clear flex-vc"
                        type={"stophour"}
                        style={{ width: '18.4%' }}
                    /> */}
                    <div className="mo-inp cityinput" style={{ width: '12%' }}>
                        <div className="single--lady">
                            <Checkbox
                                onClick={() => this.state.singleLadyDisabled ? null : this.setState({ singleLady: !this.state.singleLady })}
                                active={this.state.singleLady == 1}
                                disabled={this.state.singleLadyDisabled == 1}
                            />
                            <div className="text"> {t(SINGLE_LADY)}</div>
                        </div>
                    </div>
                    <div className="modifybutton" onClick={this.modifySrch}>
                        MODIFY
                    </div>
                </div>
                <div className="darklayer"></div>
            </section>
        );
    }
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(LinkModify);
